import * as React from 'react'
import { AiOutlineClose } from 'react-icons/ai'
import { useWatch, Control } from 'react-hook-form'
import { T2EFormData } from 'hooks/useTranslationForm'

interface Props {
   control: Control<T2EFormData>
   reset: () => void
}

const ResetButton = ({ control, reset }: Props) => {
   const sourceText = useWatch({ control, name: 'sourceText' })
   return sourceText ? (
      <div className="absolute top-6 right-6" onClick={reset}>
         <AiOutlineClose size={24} className="cursor-pointer" />
      </div>
   ) : null
}
export default ResetButton
